import { Drawer, Portal, CloseButton } from '@chakra-ui/react';
import Sidebar from '@/components/sidebar';

export default function ToolsDrawer({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) {

  return (
    <Drawer.Root open={isOpen} size='sm' placement='bottom' onOpenChange={onClose}>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content>
            <Drawer.Header>
              <Drawer.CloseTrigger asChild>
                <CloseButton size='md' />
              </Drawer.CloseTrigger>
              <Drawer.Title>Actions</Drawer.Title>
            </Drawer.Header>
            <Drawer.Body paddingTop='0' paddingLeft='3' paddingBottom='6'>
              <Sidebar onClose={onClose} />
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
}
